// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../dist/gui.d.ts" />

export default class TestStyle {

    public constructor(app: vf.Application, uiStage: vf.gui.Stage) {
        this.onLoad(app, uiStage)
    }

    private _label?: vf.gui.Label;
    private _rect?: vf.gui.Rect;
    private _buttonList: vf.gui.Label[] = [];
    private onRelease() {
        if (this._label) {
            this._label.removeAllListeners();
            this._label.parent && this._label.parent.removeChild(this._label);
            this._label.release();
            this._label = undefined;
        }
        if (this._rect) {
            this._rect.removeAllListeners();
            this._rect.parent && this._rect.parent.removeChild(this._rect);
            this._rect.release();
            this._rect = undefined;
        }
        if (this._buttonList && this._buttonList.length > 0) {
            this._buttonList.forEach(element => {
                element.removeAllListeners();
                element.parent && element.parent.removeChild(element);
                element.release();
            });
            this._buttonList = [];
        }
    }

    private onLoad(app: vf.Application, uiStage: vf.gui.Stage) {

        /** 基础文本展示 */
        const label = new vf.gui.Label();
        label.style.left = uiStage.width >> 1;
        label.style.top = 200;
        label.style.width = 200;
        label.style.height = 100;
        label.text = "测试字体";
        uiStage.addChild(label);


        const rect = new vf.gui.Rect();
        rect.color = 0;
        rect.width = 50;
        rect.height = 100;


        const style = label.style;

        this.getButton('清空高度与宽度', () => {
            style.width = NaN;
            style.height = NaN;
        }, uiStage, 15, 0);

        this.getButton('改变文字内容', () => {
            label.text += "测试字体";
        }, uiStage, 15, 0);

        this.getButton('设置/清空backgroundColor', () => {
            if (style.backgroundColor !== 0xffcccc) {
                style.backgroundColor = 0xffcccc;
            } else {
                style.backgroundColor = undefined; // or ''
            }
        }, uiStage, 15, 0);

        this.getButton('设置/清空backgroundRadius', () => {
            if (style.backgroundRadius !== 10) {
                style.backgroundRadius = 10;
            } else {
                style.backgroundRadius = 0;
            }
        }, uiStage, 15, 0);

        this.getButton('设置/清空backgrounImage', () => {
            if (style.backgroundImage !== './assets/bg.png') {
                style.backgroundImage = './assets/bg.png';
            } else {
                style.backgroundImage = ""; // or undefined
            }
        }, uiStage, 15, 0);

        this.getButton('设置/清空backgroundSize', () => {
            if (style.backgroundSize === undefined) {
                style.backgroundImage = './assets/bg.png';
                style.backgroundSize = [100, 60];
            } else {
                style.backgroundSize = undefined; // or undefined
            }
        }, uiStage, 15, 0);

        this.getButton('设置移动/清空backgroundPositionX', () => {
            if (style.backgroundPositionX !== 100) {
                style.backgroundImage = './assets/bg.png';
                vf.gui.Tween.to(style, { backgroundPositionX: 100 }, 2000).start();
            } else {
                label.style.backgroundPositionX = 0; // or undefined
            }
        }, uiStage, 15, 0);

        this.getButton('设置移动/清空backgroundPositionY', () => {
            if (style.backgroundPositionY !== 50) {
                style.backgroundImage = './assets/bg.png';
                vf.gui.Tween.to(style, { backgroundPositionY: 50 }, 2000).start();
            } else {
                label.style.backgroundPositionY = 0; // or undefined
            }
        }, uiStage, 15, 0);


        this.getButton('设置/清空maskImage', () => {
            if(style.maskImage){
                style.maskImage = undefined;
            }else{
                style.maskImage = rect;
            }
            
        }, uiStage, 15, 0);


        this.getButton('卸载', () => {
            label.$background.release();
        }, uiStage, 15, 0);
    }

    private posY = 15;
    private getButton(title: string, fun: Function, target: any, x: number, y: number) {
        const button = new vf.gui.Label;
        button.style.fontSize = 24;
        button.style.fontFamily = 'PingFang-SC-Medium,PingFang-S';
        button.style.fontWeight = 500;
        button.style.color = 0xffffff;
        button.style.lineHeight = 45;
        button.text = title;
        button.interactabled = true;
        button.x = x;
        button.y = this.posY;
        button.on(vf.gui.Interaction.TouchMouseEvent.onClick, fun);
        target.addChild(button);
        this.posY = this.posY + 25 + y;
        this._buttonList.push(button);
    }

}

